export async function extractClipboardData(data: ClipboardItem | DataTransfer) {
    if (!data) {
        return undefined;
    }

    const parsed = await Promise.all(
        Array.from(data.types).map(async (type) => {
            const isDataTransfer = data instanceof DataTransfer;
            const blob = isDataTransfer ? data.getData(type) : await data.getType(type);
            return typeof blob === 'string' ? blob : await blob.text();
        })
    );
    return parsed.join('');
}
